export const UPDATE_DEBOUNCE_MS = 500

export const INVALID_PROMO_CODE_MESSAGE = "This code isn't available"
export const PROMO_CODE_FAILED_MESSAGE = 'Something went wrong. Please try again.'
export const PROMO_CODE_NO_LONGER_AVAILABLE_MESSAGE =
  'Your promotion code is no longer available. Please remove it and try again.'

export const UPDATE_FAILED_MESSAGE =
  'Something went wrong. Please refresh the page and try again. If the problem persists, please contact our customer support at hello@joinzoe.com.'

export const PROMO_CODE_BLOCKS_UPDATE_MESSAGE =
  "Your promotion code doesn't apply to this order. Remove it, or undo your last change, to continue."

export const ADDRESS_TAX_FAILED_MESSAGE = "We can't calculate tax for this address. Please check it and try again."

export const TERMS_REQUIRED_MESSAGE = 'Please accept the terms to continue.'
export const PAY_FAILED_MESSAGE = 'Something went wrong. Please try again.'
